import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useApi from "../../../hooks/useApi";
import useSnack from "../../../hooks/useSnack";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import Footer from "../../../components/footer";
import SnackAlert from "../../../components/SnackAlert";
import ListingDetails from "../../../components/ListingDetails";
import SwiperImages from "../../../components/SwiperImages";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { Link } from "react-router-dom";
import { AutoGraph, KingBed, NavigateBefore } from "@mui/icons-material";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import { LoadingButton } from "@mui/lab";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import HeaderAdmin from "../../../components/headerAdmin";

const ModalReject = ({
  modalOpen,
  setModalOpen,
  loadingButtonDelete,
  handlerDelete,
}) => {
  return (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h2" variant="h6" mb={2}>
          Confirmación
        </Typography>
        <Typography mb={2} fontWeight="normal">
          ¿Estás seguro que quieres rechazarlo?
        </Typography>
        <Stack flexDirection="row" justifyContent="flex-end">
          <Button
            sx={{ mr: 1.5 }}
            onClick={() => setModalOpen(false)}
            disabled={loadingButtonDelete ? true : false}
          >
            CANCELAR
          </Button>
          <LoadingButton
            loading={loadingButtonDelete}
            variant="contained"
            sx={{ color: "white" }}
            onClick={handlerDelete}
          >
            CONFIRMAR
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  );
};

function ManagePropertyAdmin() {
  const params = useParams();

  const [mainData, setMainData] = useState();
  const [listData, setListData] = useState([
    {
      title: "PRECIO",
      icon: LocalAtmIcon,
      value: "",
    },
    {
      title: "m2",
      icon: AspectRatioIcon,
      value: "",
    },
    // {
    //   title: "TIPO",
    //   icon: MapsHomeWorkIcon,
    //   value: "",
    // },
    {
      title: "UBICACIÓN",
      icon: FmdGoodOutlinedIcon,
      value: "",
    },

    {
      title: "PROPOSITO",
      icon: ArticleOutlinedIcon,
      value: "",
    },
    {
      title: "HABITACIONES",
      icon: KingBed,
      value: "",
    },
    {
      title: "BAÑOS",
      icon: BathtubIcon,
      value: "",
    },
  ]);

  // UTILS
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingButtonDelete, setLoadingButtonDelete] = useState(false);

  const navigate = useNavigate();

  const sellProject = async () => {
    setIsLoading(true);
    loadApi(`superadmin/states/verified/${params.id}`, true, "put", {
      verified: "sold",
    })
      .then((response) => {
        showSnack(response.data.message, "success");
        setModalOpen(false);
        setTimeout(() => {
          navigate("/dashboard/property/accepted");
        }, 3000);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setIsLoading(false));
  };

  const rentProject = async () => {
    setIsLoading(true);
    loadApi(`superadmin/states/verified/${params.id}`, true, "put", {
      verified: "rented",
    })
      .then((response) => {
        showSnack(response.data.message, "success");
        setModalOpen(false);
        setTimeout(() => {
          navigate("/dashboard/property/accepted");
        }, 3000);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setIsLoading(false));
  };

  const acceptProject = async () => {
    setIsLoading(true);
    loadApi(`admin_panel/update_status_states/${params.id}`, true, "put", {
      verified: 1,
    })
      .then((response) => {
        showSnack(response.data.message, "success");
        setModalOpen(false);
        setTimeout(() => {
          navigate("/dashboard/property/pending");
        }, 3000);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setIsLoading(false));
  };
  const handlerDelete = () => {
    setLoadingButtonDelete(true);
    loadApi("admin_panel/update_status_states/" + params.id, true, "put", {
      verified: 2,
    })
      .then((response) => {
        showSnack("Inmueble rechazado", "success");
        setModalOpen(false);
        setTimeout(() => {
          navigate("/dashboard/property/pending");
        }, 3000);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setLoadingButtonDelete(false));
  };

  useEffect(() => {
    setOpenBackDrop(true);
    loadApi("superadmin/states/" + params.id, true, "get")
      .then((response) => {
        const dataMapping = {
          PRECIO: parseInt(response.data.price).toLocaleString("es-ES") + "Є",
          m2: response.data.m2,
          // TIPO: filteredData[0].type,
          UBICACIÓN: response.data.location,
          PROPOSITO: response.data.purpose_use,
          HABITACIONES: response.data.bedrooms,
          BAÑOS: response.data.bathrooms,
        };
        const updatedListData = listData.map((item) => ({
          ...item,
          value: dataMapping[item.title],
        }));
        setListData(updatedListData);
        setMainData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setOpenBackDrop(false);
      });
  }, []);

  console.log(mainData);
  return (
    <>
      <HeaderAdmin />
      <Stack
        component="main"
        sx={{
          minHeight: "90vh",
          width: { xs: "100vw", sm: "90vw", md: "85vw", lg: "65vw" },
          marginInline: "auto",
          backgroundColor: "white",
          pb: 4,
          placeContent: "center",
        }}
      >
        {mainData && (
          <>
            {/* IF THE ARRAY IS EMPTY THIS WILL BE SHOW IT */}
            {mainData.error && (
              <Stack sx={{ mt: 10 }}>
                <Typography textAlign="center" variant="h5">
                  Lo sentimos, datos no encontrados
                </Typography>
              </Stack>
            )}
            {/* IN CASE THAT THE ERROR KEY DOESNT EXIST, THE DATA IS RENDERED */}
            {!mainData.error && (
              <Stack>
                <SwiperImages
                  data={mainData.photo_profile}
                  section="property"
                />
                <Stack px={{ xs: 2, md: 4 }}>
                  <Stack component="section" pt={5}>
                    <Typography component="h2" variant="h5" mb={2}>
                      {mainData.name}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        backgroundColor: "secondary.typePropertySpan",
                        width: "fit-content",
                        px: 2,
                        py: 0.5,
                        borderRadius: 3,
                        mb: 5,
                        fontWeight: "normal",
                      }}
                    >
                      {mainData.type}
                    </Typography>
                    <ListingDetails data={listData} />
                  </Stack>
                  <Stack
                    component="section"
                    mb={{ xs: 2, lg: 5 }}
                    mt={{ xs: 3, lg: 7 }}
                  >
                    <Typography component="h3" variant="h5" mb={2}>
                      Descripción
                    </Typography>
                    <Typography sx={{ fontWeight: "normal", mb: 5 }}>
                      {mainData.information}
                    </Typography>
                  </Stack>
                  <SwiperImages data={mainData.gallery} slides={3} />

                  <Stack
                    component="section"
                    flexDirection="row"
                    gap={2}
                    sx={{
                      width: { xs: "85%", md: "100%" },
                      marginInline: "auto",
                      justifyContent: "right",
                    }}
                  >
                    {mainData.purpose_use === "Venta" ? (
                      <LoadingButton
                        loading={isLoading}
                        disabled={mainData.verified === "sold"}
                        variant="contained"
                        onClick={sellProject}
                        sx={{
                          alignItems: "center",
                          gap: 1,
                          width: {
                            xs: "100%",
                            md: "fit-content",
                          },
                          borderRadius: 2,
                          color: "white",
                          px: { xs: 0, md: 5 },
                          "&:hover": {
                            backgroundColor: "primary.300",
                          },
                        }}
                      >
                        <CheckCircleIcon />
                        {mainData.verified === "sold"
                          ? "Ya está vendido"
                          : "Vender"}
                      </LoadingButton>
                    ) : null}
                    {mainData.purpose_use === "Arriendo" ? (
                      <LoadingButton
                        loading={isLoading}
                        disabled={mainData.verified === "rented"}
                        variant="contained"
                        onClick={rentProject}
                        sx={{
                          alignItems: "center",
                          gap: 1,
                          width: {
                            xs: "100%",
                            md: "fit-content",
                          },
                          borderRadius: 2,
                          color: "white",
                          px: { xs: 0, md: 5 },
                          "&:hover": {
                            backgroundColor: "primary.300",
                          },
                        }}
                      >
                        <CheckCircleIcon />
                        {mainData.verified === "rented"
                          ? "Ya está arrendado"
                          : "Arrendar"}
                      </LoadingButton>
                    ) : null}
                  </Stack>
                </Stack>
              </Stack>
            )}
          </>
        )}
      </Stack>
      <ModalReject
        handlerDelete={handlerDelete}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        loadingButtonDelete={loadingButtonDelete}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default ManagePropertyAdmin;
